var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"course-step"},[_c('weui-group',{attrs:{"notitle":true,"tips":"绑定教练即可随时同步教练的课程安排，并且可以发起课程申请、查看过往锻炼记录。"}},[_c('weui-button-cell',{attrs:{"to":{ name: _vm.ROUTE_SHARE_BINDING, params: { hash: this.hash } },"replace":""}},[_vm._v("立刻绑定您的私人教练")])],1),_vm._v(" "),_c('course-view',{attrs:{"course":_vm.course}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03dc2f24","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/share/Course.vue
// module id = null
// module chunks = 